module.exports = __webpack_public_path__ + "5e5ce499b3a9f062995d0b127c0c6440.svg";